import { GradientedScroller, connected, withErrorBoundary, NoResults} from 'shared'
import { TopLevelPage } from 'ui'
import SlideEventCard from 'ui/events/SlideEventCard'
import PeopleCard from 'ui/people/PeopleCard'
import { useEffect, useState } from 'react';

let intervalId = null;

const GuestSecretCalenderView = ({ match }) => {
  const feedItemId = match.params.id;
  const [slides, setSlides] = useState([]);
  const [sliderTime, setSliderTime] = useState("5000");
  const [refreshTime, setRefreshTime] = useState(2000);
  const [initialized, setInitialized] = useState(false);
  const [userCounter, setUserCounter] = useState();
  const [eventCounter, setEventCounter] = useState();

  const loadSlideData = () => {
    return Backend.get('/slides', { user_set_counter: userCounter, event_counter: eventCounter }).then((data) => {
      setSlides(data.slides);
      setSliderTime(data.slider_time);
      setRefreshTime(data.refresh_time ? data.refresh_time : 3600000);
      setUserCounter(data.user_set_counter ? data.user_set_counter : 0);
      setEventCounter(data.event_counter);
    });
  };

  useEffect(() => {
    console.log("Inside useEffect");
    if (!initialized) {
      loadSlideData().then(() => setInitialized(true));
    }

    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(() => loadSlideData(), refreshTime);

    return;
  }, [initialized, refreshTime, userCounter, eventCounter]);

  return (
    <TopLevelPage className="Calendar is-diabled" modelId={feedItemId} base="/community-calendar">
      <div id="carouselExampleSlidesOnly" className="carousel slide" data-ride="carousel">
        <div className="carousel-inner">
          {slides?.length > 0 ? slides.map((slide, index) => (
            <div key={index} className={index === 0 ? "carousel-item active" : "carousel-item"} data-interval={slide.timer * 1000}>
              {slide.type === 'image' ? (
                <div className="iframe-modal">
                  <img src={slide.data} style={{ width: '100%', height: '500px' }} />
                </div>
              ) : slide.type === 'web' ? (
                <div className="iframe-modal">
                  <iframe src={slide.file_path} width="100%" height="500px" scrolling="no" style={{ border: 'none', overflow: 'hidden' }} />
                </div>
              ) : slide.type === 'checkin' ? (
                <div>
                  <div className="row justify-content-center">
                    <div className="col-md-8">
                      <h1 className="section-heading-lowercase my-3">{slide.data.title}</h1>
                    </div>
                  </div>
                  <GradientedScroller containerClassName="feed-columns row">
                    {slide.users.map((model) => (
                      <section className="feed-column col-sm-6 col-lg-4 col-xl-3" key={model.uid}>
                        <div className="feed-column-body">
                          <PeopleCard user={model} key={model.id} base='/large-screen' />
                        </div>
                      </section>
                    ))}
                  </GradientedScroller>
                </div>
              ) : slide.type === 'event' ? (
                <div>
                  {slide.data.title ? (
                    <div className="row justify-content-center">
                      <div className="col-md-8">
                        <h1 className="section-heading-lowercase my-3">{slide.data.title}</h1>
                      </div>
                    </div>
                  ) : (
                    <div className="centered-title"></div>
                  )}
                  {slide.data.events.length === 0 ? (
                    <NoResults>We’re sorry, this section contains no events.</NoResults>
                  ) : (
                    <GradientedScroller containerClassName="feed-columns row">
                      {slide.data.events.map((model) => (
                        <section className="feed-column col-sm-6 col-lg-4 col-xl-3" key={model.uid}>
                          <div className="feed-column-body">
                            <SlideEventCard event={model} key={model.id} base='/large-screen' />
                          </div>
                        </section>
                      ))}
                    </GradientedScroller>
                  )}
                </div>
              ) : (
                <div key="noSlides">No slides available</div>
              )}
            </div>
          )) : (
            <div key="noSlides">No slides available</div>
          )}
        </div>
      </div>
    </TopLevelPage>
  );
};

export default withErrorBoundary(connected(GuestSecretCalenderView));
